import { AlertTriangle } from "lucide-react";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { openBillingPortal } from "@/lib/api";
import { toast } from "sonner";

export default function PastDueBanner() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  if (!user || user.subscription_status !== "past_due" || !user.past_due_since) return null;
  const since = new Date(user.past_due_since);
  const expires = new Date(since.getTime() + 3 * 24 * 60 * 60 * 1000);
  const daysLeft = Math.max(0, Math.ceil((expires - new Date()) / (24 * 60 * 60 * 1000)));
  const expired = daysLeft <= 0;

  const fixBilling = async () => {
    setLoading(true);
    try {
      const { portal_url } = await openBillingPortal(window.location.origin + "/parent");
      window.location.href = portal_url;
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Couldn't open billing portal");
      navigate("/pricing");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      data-testid="past-due-banner"
      className={`nb-border ${expired ? "bg-[#FFB38E]" : "bg-[#FFE066]"} text-black px-4 py-2 flex items-center justify-between gap-3 text-sm font-bold`}
    >
      <div className="flex items-center gap-2">
        <AlertTriangle className="w-4 h-4 shrink-0" strokeWidth={2.5} />
        {expired
          ? "Payment failed. Access has been paused, please update your card."
          : `Payment failed. Access ends in ${daysLeft} day${daysLeft === 1 ? "" : "s"}, please update your card.`}
      </div>
      <button
        data-testid="past-due-fix-billing"
        onClick={fixBilling}
        disabled={loading}
        className="nb-border rounded-lg bg-white px-3 py-1.5 text-xs hover:nb-shadow"
      >
        {loading ? "Opening…" : "Fix billing"}
      </button>
    </div>
  );
}
